import axios from "axios";
import * as d3 from "d3";
import {numberFormat, pieChart} from '../functions'

export default function (chart, divId, vizName, filterParam) {
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName
    console.log("Chart vizName called:", vizName, divId, url)

    // load the data
    axios.post(url, filterParam).then(res => {
        let data = res.data;
        console.log("data is:", data)

        var types = d3.nest()
            .key(function (d) {
                return d.dim1_name
            })
            .entries(data);

        console.log("types", types)

        //  var width = 600, height = 300;
        var svg = d3.select(divId).selectAll("svg").remove();
        svg = d3.select(divId)
            .selectAll('svg')
            .data(types)
            .enter()
            .append('svg')
            .attr('width', chart.width)
            .attr('height', chart.height)
        //   .call(responsivefy)
        // .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

        var
            radius = 100;
        console.log("radius", radius)

        var div = d3.select(divId).append("div").attr("class", "toolTip");

        //    var div2 = d3.select(divId).append("div")

        var g = svg.append("g")
            .attr("transform", "translate(" + chart.width / 2 + "," + chart.height / 2.2 + ")");


        var color = d3.scaleOrdinal().range(pieChart);


        var types2 = d3.nest()
            .key(function (d) {
                return d.dim1_name
            })
            .rollup(function (v) {
                return d3.sum(v, function (d) {
                    return d.metric1
                })
            })
            .entries(data);


        var pie = d3.pie()
            .value(function (d) {
                return d.metric1;
            }).sort(null);

        var rscale = d3.scaleSqrt()
            .domain([d3.min(types2, function (d) {
                return d.value
            }),
                d3.max(types2, function (d) {
                    return d.value
                })])
            .range([5, 40])


        //   console.log("data2", data2)
        var tots = d3.sum(data, function (d) {
            return d.metric1;
        });

        //  var total=d3.nest(types.values,d=>d.dim1_name)

        //  console.log("total",total)

        console.log("tots", tots)

        console.log("datapie", data)

        var path = d3.arc()
            .outerRadius(radius - 5)
            .innerRadius(40);


        var elemEnter2 = svg
            .append("g")
            .attr("transform", "translate(150, 50)"); // prevent svg crops first circle
        //   .attr("transform", "translate("0,100);

        var circles2 = elemEnter2
            .append("circle")
            .data(types2)
            .attr("r", function (d) {
                return rscale(d.value)
            })
            // .attr("r", 20)
            //function(d){ return rscale(d.values.metric1)})
            .style("fill", "#838996")
            //   .style("fill", function(d) { return color(d.dim2_name)}
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(d.key + '<br>' +
                    numberFormat(d.value))
                    .style("display", "block")
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition()
                    .style("display", "none")
                    .style("opacity", 0)
            });
        console.log(circles2)
        /*circles2.append("text")
            .attr("dx",  20)
            .text(function(d){
                return d.key + ': ' + numberFormat(d.value) + ' (' +  Math.round((d.value / tots) * 100) +'%)'
            })*/


        var arc = g.selectAll(".arc")
            .data(function (d) {
                console.log("Pies", pie(d.values));
                return pie(d.values)
            })
            .enter().append("g")
            .attr("class", "arc");


        arc.append("path")
            .attr("d", path)
            .attr("fill", function (d) {
                return color(d.data.dim2_name);
            })
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(d.data.dim2_name + '<br>' +
                Math.round((d.endAngle - d.startAngle) / (2 * Math.PI) * 100) + '%' + '(' + numberFormat(d.data.metric1) + ' out of ' + numberFormat(types2.filter(f=> f.key==d.data.dim1_name).map(f=> f.value)[0]) + ')')
                    .style("display", "block")
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition()
                    .style("display", "none")
                    .style("opacity", 0)
            });


        var title = svg.append("g")
            .data(types2)
            .append("text")
            .attr("x", 150)
            .attr("y", 120)
            .style('text-anchor', 'middle')
            .attr("dominant-baseline", "central")
            .attr('font-weight', 'bold')
            .text(function (d) {
                return d.key + ': ' + numberFormat(d.value) + ' (' + Math.round((d.value / tots) * 100) + '%)'
            })

        console.log(title)


        var legend = svg.append('g')
            .attr("class", "legend")
            .selectAll("g")
            .data(function (d) {
                return pie(d.values)
            }, function (d) {
                return d.data.dim2_name;
            })//setting the data as we know there are only two set of data[programmar/tester] as per the nest function you have written
            .enter().append("g")
            .attr("transform", function (d, i) {
                return "translate(0," + (i * 20 + 30) + ")";
            });

        legend.append("rect")
            .attr('x', 70)
            .attr('y', 340)
            .attr("width", 18)
            .attr("height", 18)
            .style("fill", function (d) {
                return color(d.data.dim2_name);
            });

        legend.append("text")
            .attr("x", 100)
            .attr("y", 350)
            .attr("dy", ".35em")
            .text(function (d) {
                return Math.round((d.endAngle - d.startAngle) / (2 * Math.PI) * 100) + '%' + ' ' + d.data.dim2_name;
            });
    })
}
